module.exports = __webpack_public_path__ + "img/info_3.810fd524.png";